import { createSelector } from 'reselect'

import { RootState } from '@tabeeb/store'
import { TenantPermission } from '@tabeeb/enums'
import { hasTenantPermission } from '@tabeeb/modules/permissions/selectors'
import { getIsTenantAnnouncementsEnabled } from '@tabeeb/modules/appConfigState/selectors'

import { queryClient } from '@tabeeb/services/queryClient'

import { AnnouncementScope } from '../enums'
import { ArticlesQueryKeys } from '../queries'

// TODO: Remove this after session tabs refactor
export const getUnreadTrainingMaterialsCount = (state: RootState, { contentId }: { contentId: number }) =>
  queryClient.getQueryData<number | undefined>([ArticlesQueryKeys.UnreadTrainingMaterialsCount, contentId]) ?? 0

export const getHasManageSystemAnnouncementsPermission = (state: RootState) =>
  hasTenantPermission(state, TenantPermission.ManageSystemAnnouncements)

export const getHasManageCorporationAnnouncementsPermission = (state: RootState) =>
  hasTenantPermission(state, TenantPermission.ManageCorporationCertificatesAndQualifications)

export const getHasManageTenantAnnouncementsPermission = (state: RootState) =>
  hasTenantPermission(state, TenantPermission.ManageTenantAnnouncements)

export const getHasManageTrainingMaterialsPermission = (state: RootState) =>
  hasTenantPermission(state, TenantPermission.ManageTrainingMaterials)

export const getAvailableAnnouncementScopes = createSelector(
  [
    getHasManageSystemAnnouncementsPermission,
    getHasManageCorporationAnnouncementsPermission,
    getHasManageTenantAnnouncementsPermission,
    getIsTenantAnnouncementsEnabled,
  ],
  (
    hasManageSystemAnnouncementsPermission,
    hasManageCorporationAnnouncementsPermission,
    hasManageTenantAnnouncementsPermission,
    isTenantAnnouncementsEnabled
  ) => {
    const scopes = []

    if (hasManageSystemAnnouncementsPermission) {
      scopes.push(AnnouncementScope.System)
    }

    if (hasManageCorporationAnnouncementsPermission) {
      scopes.push(AnnouncementScope.Corporation)
    }

    if (hasManageTenantAnnouncementsPermission && isTenantAnnouncementsEnabled) {
      scopes.push(AnnouncementScope.Tenant)
    }

    return scopes
  }
)
